import React from 'react';
import { Icon } from './Icon.js';
export const IconMagnifier3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 21L16.5 16.5L16.7806 16.7806", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("circle", { cx: "11", cy: "11", r: "8", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M15 11C15 8.79086 13.2091 7 11 7", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconMagnifier3.js.map